"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSuffixWrapper = exports.InputGroup = exports.Input = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
const styles_1 = require("../styles");
const NUMBER_FONT_SIZE_PX = 14;
const FIELD_HEIGHT_PX = 26;
exports.Input = styled_components_1.default.input `
  font-family: SwegonBrown;
  color: ${colors_1.BLACK};
  background-color: ${colors_1.LIGHT_GREY};
  font-size: ${NUMBER_FONT_SIZE_PX}px;
  line-height: 24px;
  padding-left: 8px;
  height: ${FIELD_HEIGHT_PX}px;
  outline: none;
  border: 0;
  border-bottom: 1px solid ${colors_1.GREY1};
  width: 100%;
  color: ${colors_1.GREY4};
  padding-top: 3px;
  ::placeholder {
      color: ${colors_1.GREY2};
  }
  &:hover {
      border-bottom: 1px solid ${colors_1.BLACK};
  }
  &:focus {
      border: 1px solid ${colors_1.DARK_GREEN};
      border-bottom: 3px solid ${colors_1.DARK_GREEN};
  }

  ${({ $hasValue }) => $hasValue &&
    (0, styled_components_1.css) `
      border-bottom: 1px solid ${colors_1.GREY2};
    `}
  ${({ $hasWarning }) => $hasWarning &&
    (0, styled_components_1.css) `
      background-color: ${colors_1.LIGHT_GREY};
      border-bottom: 1px solid ${colors_1.YELLOW};
      &:hover {
        border-bottom: 1px solid ${colors_1.YELLOW};
      }
      &:focus {
        outline: none;
        border: 1px solid ${colors_1.YELLOW};
        border-bottom: 3px solid ${colors_1.YELLOW};
      }
    `}
  ${({ $hasError }) => $hasError &&
    (0, styled_components_1.css) `
      background: ${colors_1.RED_BACKGROUND};
      border-bottom: 1px solid ${colors_1.RED};
      &:hover {
        border-bottom: 1px solid ${colors_1.ORANGE};
      }
      &:focus {
        outline: none;
        background-color: ${colors_1.RED_BACKGROUND};
        border: 1px solid ${colors_1.ORANGE};
        border-bottom: 3px solid ${colors_1.ORANGE};
      }
    `}     

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      border: 1px solid ${colors_1.GREY1};
      color: ${colors_1.GREY2};
      &:hover {
        border-bottom: 1px solid ${colors_1.GREY1};
      }
    `}

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    opacity: 1;
  }
`;
exports.InputGroup = styled_components_1.default.span `
  position: relative;
  width: 100%;
`;
exports.InputSuffixWrapper = (0, styled_components_1.default)(styles_1.ColorStates) `
  margin-left: auto;
  position: absolute;
  top: ${({ $unitHeight }) => (FIELD_HEIGHT_PX - $unitHeight) / 2}px;
  color: ${colors_1.GREY4};
  right: 24px;
  font-size: ${NUMBER_FONT_SIZE_PX}px;

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      color: ${colors_1.GREY2} !important;
    `}
`;
//# sourceMappingURL=NumberInputFieldCompact.styles.js.map